import script from "./HoverBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HoverBar.vue?vue&type=script&setup=true&lang=js"

import "./HoverBar.vue?vue&type=style&index=0&id=2fc843a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc843a4"]])

export default __exports__